import _extends from "@babel/runtime-corejs3/helpers/extends";

var _context;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import logger from "../../../util/logger";
import React from 'react';
import * as _ from "../../../util/lodash";
import Isvg from 'react-inlinesvg';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import { assetServices, sizes, uploadAssetTypes } from "../../../enums";
import { ConfigService } from "../../../services";
import Image from "../image";
import Video from "../video";
import assetRefService from "../../../util/asset";
import queryString from "../../../util/query-string";
var Media = createComponent({
  displayName: 'Media',
  propTypes: {
    reference: PropTypes.string.isRequired,
    poster: PropTypes.string,
    onClick: PropTypes.func,
    onLoad: PropTypes.func,
    size: PropTypes.oneOfType([PropTypes.oneOf(_concatInstanceProperty(_context = []).call(_context, sizes.ALL, ['fluid'])), PropTypes.shape({
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })]),
    isCircular: PropTypes.bool
  },
  defaultProps: {
    onClick: undefined,
    onLoad: undefined,
    size: undefined,
    isCircular: false,
    poster: undefined
  },
  render: function render(_ref) {
    var reference = _ref.reference,
        onClick = _ref.onClick,
        onLoad = _ref.onLoad,
        style = _ref.style,
        size = _ref.size,
        isCircular = _ref.isCircular,
        poster = _ref.poster;
    var asset = assetRefService.deserialize(reference);
    logger.warn('Media: isCircular is only supported for images at the moment', asset.assetType !== uploadAssetTypes.IMAGE && isCircular);
    logger.warn('Media: poster only supported for Video', !!poster && asset.assetType !== uploadAssetTypes.VIDEO_URL);

    if (asset.assetType === uploadAssetTypes.IMAGE) {
      var url = getImageUrl(asset);

      if (url instanceof Error) {
        return /*#__PURE__*/React.createElement("span", null, "tried to render: <Media reference=\"" + reference + "\"/> but " + url.message);
      }

      url = assetRefService.cleanUrl(url);
      return /*#__PURE__*/React.createElement(Image, {
        onClick: onClick,
        onLoad: onLoad,
        size: size || asset.dimensions,
        src: url,
        style: style,
        isCircular: isCircular
      });
    } else if (asset.assetType === uploadAssetTypes.GENERATED_SVG) {
      var _context2;

      if (!_startsWithInstanceProperty(_context2 = asset.location).call(_context2, 'data:image/')) {
        return /*#__PURE__*/React.createElement("span", null, "tried to render: <Media reference=\"" + reference + "\"/> but did not find a datauri: 'data:image/'");
      }

      return /*#__PURE__*/React.createElement(Image, {
        onClick: onClick,
        onLoad: onLoad,
        size: size || asset.dimensions,
        src: asset.location,
        style: style,
        isCircular: isCircular
      });
    } else if (asset.assetType === uploadAssetTypes.INLINE_SVG) {
      return /*#__PURE__*/React.createElement(Isvg, {
        onClick: onClick,
        onLoad: onLoad,
        wrapper: function wrapper() {
          return /*#__PURE__*/React.createElement("span", {
            style: _extends({}, size),
            className: "isvg"
          });
        },
        src: assetRefService.cleanUrl(asset.location),
        cacheRequests: true,
        style: style
      });
    } else if (asset.assetType === uploadAssetTypes.VIDEO_URL) {
      logger.warn('Media: onClick/onLoad callbacks are not supported for video media', !!onClick || !!onLoad);
      logger.warn('Media: size is not supported for video media', !!size);

      var _url = getVideoUrl(asset);

      var posterAsset = assetRefService.deserialize(poster);
      var posterUrl = poster ? getPosterUrl(posterAsset) : getPosterUrl(asset);
      return /*#__PURE__*/React.createElement(Video, {
        width: asset.dimensions.width,
        src: assetRefService.cleanUrl(_url),
        status: asset.status,
        style: style,
        poster: posterUrl
      });
    } else if (asset.assetType === uploadAssetTypes.GIF) {
      logger.warn('Media: video gif is only supported for Twitter', asset.service !== assetServices.TWITTER);
      return /*#__PURE__*/React.createElement(Video, {
        width: asset.dimensions.width,
        src: assetRefService.cleanUrl(asset.location),
        style: style,
        type: asset.assetType
      });
    }

    logger.warn("Media: tried to render <Media reference=\"" + reference + "\"/> but " + asset.assetType + " type is not handled by Media", true);
    return /*#__PURE__*/React.createElement("span", null, "Media unavailable");
  }
});

function getImageUrl(asset) {
  var _context3;

  if (_indexOfInstanceProperty(_context3 = [assetServices.BAZAARVOICE, assetServices.EXT, assetServices.FACEBOOK, assetServices.FLICKR, assetServices.GOOGLEPLUS, assetServices.INSTAGRAM, assetServices.LINKEDIN, assetServices.LITHIUM, assetServices.NEWSCRED, //WYN-194
  assetServices.PINTEREST, assetServices.TWITTER, assetServices.VIMEO, assetServices.VINE, assetServices.VK, assetServices.WEB_URL, assetServices.YOUTUBE, assetServices.PEXELS]).call(_context3, asset.service) !== -1) {
    return asset.location;
  } else if (asset.service === assetServices.ASSET) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.accountAssetURL + "/" + asset.location;
  } else if (asset.service === assetServices.BUNDLE) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.consoleAssetURL + "/" + asset.location;
  } else if (asset.service === assetServices.STATIC) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.staticResourceURL + "/" + asset.location;
  } else if (asset.service === assetServices.UGC) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.accountUGCAssetURL + "/" + asset.location;
  } else if (asset.service === assetServices.UGCX) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.accountUGCxAssetURL + "/" + asset.location;
  } else if (asset.service === assetServices.MUX) {
    return getPosterUrl(asset);
  } else {
    return new Error(asset.service + " is not supported by image");
  }
}

function getVideoUrl(asset) {
  if (asset.service === assetServices.MUX) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.muxVideoUrl + "/" + asset.location + ".m3u8";
  } else return asset.location;
}

function getPosterUrl(asset) {
  if (asset.service === assetServices.MUX) {
    return _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.muxImageUrl + "/" + asset.location + "/thumbnail.jpg" + (asset.settings ? "?" + queryString.serialize(asset.settings) : '');
  } else return asset.location;
}

export default whitelistStyles(['objectFit', 'objectPosition', 'maxWidth'])(Media);
//# sourceMappingURL=media.js.map